import { useState } from 'react';
import { CommonType } from '@app/domain/model/CommonType';

export function useLifeInsuranceWizardCallbacks() {
    const [hasSportHobbies, setHasSportHobbies] = useState<boolean>(false);

    const handleHaveSportsHobbyChange = (savedOption: string) => {
        setHasSportHobbies(savedOption === CommonType.True);
    };

    return {
        handleHaveSportsHobbyChange,
        hasSportHobbies,
    };
}
